import { FC } from 'react';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { StockContainersInfo } from '../../types';
import { tableFilters } from './tableFiters';
import styles from './StockContainersTable.module.scss';

type StockContainersTableProps = {
  data?: StockContainersInfo[];
  isLoading?: boolean;
};

const StockContainersTable: FC<StockContainersTableProps> = ({
  data,
  isLoading,
}) => {
  const tableColumns = getTableColumns(data);

  return (
    <div className={styles.containerListTable}>
      <Table
        columns={tableColumns}
        data={data}
        isLoading={isLoading}
        filters={tableFilters}
        filterDisplay="menu"
      />
    </div>
  );
};

export default StockContainersTable;
